import React, { Component } from 'react';
import './logoSection.css';
import DesignSection from './designSection';
import SectionBanner from './sectionBanner';
import SectionPageHeader from './sectionPageHeader';

export default class ImagesSection extends Component {
  render() {
    return (
      <div className="sectionContainer full-width">
        <SectionBanner image="/images/background-lines-gradient-purple.webp" title="Imagery" />
        <SectionPageHeader description="Approved brand imagery helps us present a consistent and compelling visual presence across platforms. Use these assets for LinkedIn profiles, marketing materials, and other public-facing channels." />
        <div id="linkedin-banners">
        <DesignSection
          title={'LinkedIn Banners'}
          subtitle={'These are a set of approved branded images that can be used for employee linkedin profiles or other marketing materials. Grab one to use on your profile.'}>
          <div style={{maxWidth:800}}>
            <div className="tiny-padding">
              <img src={'/design/linkedin-banner-light.jpg'} className="full-width tiny-bottom-margin" />
              <a className="downloadText" href="/design/linkedin-banner-light.jpg" download>
                Download
                <span className="material-symbols-rounded">download</span>
              </a>
            </div>
            <div className="tiny-padding">
              <img src={'/design/linkedin-banner-dark.jpg'} className="full-width tiny-bottom-margin" />
              <a className="downloadText" href="/design/linkedin-banner-dark.jpg" download>
                Download
                <span className="material-symbols-rounded">download</span>
              </a>
            </div>
            <div className="tiny-padding">
              <img src={'/design/spendhound-linkedin-banner-dark.png'} className="full-width tiny-bottom-margin" />
              <a className="downloadText" href="/design/spendhound-linkedin-banner-dark.png" download>
                Download
                <span className="material-symbols-rounded">download</span>
              </a>
            </div>
            <div className="tiny-padding">
              <img src={'/design/spendhound-linkedin-banner-tagline.png'} className="full-width tiny-bottom-margin" />
              <a className="downloadText" href="/design/spendhound-linkedin-banner-tagline.png" download>
                Download
                <span className="material-symbols-rounded">download</span>
              </a>
            </div>
            <div className="tiny-padding">
              <img src={'/design/spendhound-linkedin-banner-light.png'} className="full-width tiny-bottom-margin" />
              <a className="downloadText" href="/design/spendhound-linkedin-banner-light.png" download>
                Download
                <span className="material-symbols-rounded">download</span>
              </a>
            </div>
          </div>
        </DesignSection>
        </div>
        <div id="zoom-backgrounds">
        <DesignSection
          title={'Zoom Backgrounds'}
          subtitle={'Approved background images for use by employees on Zoom.'}>
          <div style={{maxWidth:800}}>
            <div className="tiny-padding">
              <img src={'/design/yipitdata-zoom-light.png'} className="full-width tiny-bottom-margin" />
              <a className="downloadText" href="/design/yipitdata-zoom-light.png" download>
                Download
                <span className="material-symbols-rounded">download</span>
              </a>
            </div>
            <div className="tiny-padding">
              <img src={'/design/yipitdata-zoom-dark.png'} className="full-width tiny-bottom-margin" />
              <a className="downloadText" href="/design/yipitdata-zoom-dark.png" download>
                Download
                <span className="material-symbols-rounded">download</span>
              </a>
            </div>
            <div className="tiny-padding">
              <img src={'/design/spendhound-zoom-dark.png'} className="full-width tiny-bottom-margin" />
              <a className="downloadText" href="/design/spendhound-zoom-dark.png" download>
                Download
                <span className="material-symbols-rounded">download</span>
              </a>
            </div>
            <div className="tiny-padding">
              <img src={'/design/spendhound-zoom-light.png'} className="full-width tiny-bottom-margin" />
              <a className="downloadText" href="/design/spendhound-zoom-light.png" download>
                Download
                <span className="material-symbols-rounded">download</span>
              </a>
            </div>
          </div>
        </DesignSection>
        </div>
        <div id="photography">
        <DesignSection
          title={'Photography'}
          subtitle={'These images are great examples of backgrounds that can be used for slides and other marketing materials. Grab one to use in your own materials.'}>
          <div className="max-width-container small-bottom-margin">
            <div className="section-padding no-top-padding">
              <div className="">
                <div className="row middle">
                  <div
                    className="small-12 medium-4 centered-text full-height small-padding">
                    <img src={'/design/images-textures/sector-autos.jpg'} className="full-width small-bottom-margin" alt="city buildings image" />
                    <a className="downloadText"  href="design/images-textures/sector-autos.jpg" download>
                      Download
                      <span className="material-symbols-rounded">download</span>
                    </a>
                  </div>
                  <div
                    className="small-12 medium-4 centered-text full-height small-padding">
                    <img src={'/design/images-textures/sector-dining.jpg'} className="full-width small-bottom-margin" alt="city buildings image" />
                    <a className="downloadText" href="/design/images-textures/sector-dining.jpg" download>
                      Download
                      <span className="material-symbols-rounded">download</span>
                    </a>
                  </div>
                  <div
                    className="small-12 medium-4 centered-text full-height small-padding">
                    <img src={'/design/images-textures/sector-ecommerce.jpg'} className="full-width small-bottom-margin" alt="city buildings image" />
                    <a className="downloadText" href="/design/images-textures/sector-ecommerce.jpg" download>
                      Download
                      <span className="material-symbols-rounded">download</span>
                    </a>
                  </div>
                  <div
                    className="small-12 medium-4 centered-text full-height small-padding">
                    <img src={'/design/images-textures/sector-gaming.jpg'} className="full-width small-bottom-margin" alt="new york cityscape" />
                    <a className="downloadText"  href="design/images-textures/sector-gaming.jpg" download>
                      Download
                      <span className="material-symbols-rounded">download</span>
                    </a>
                  </div>
                  <div
                    className="small-12 medium-4 centered-text full-height small-padding">
                    <img src={'/design/images-textures/sector-online-gambling.jpg'} className="full-width small-bottom-margin" alt="street car lights on a long exposure photo" />
                    <a className="downloadText" href="/design/images-textures/sector-online-gambling.jpg" download>
                      Download
                      <span className="material-symbols-rounded">download</span>
                    </a>
                  </div>
                  
                  <div
                    className="small-12 medium-4 centered-text full-height small-padding">
                    <img src={'/design/images-textures/sector-rideshare.jpg'} className="full-width small-bottom-margin" alt="street pedestrian image" />
                    <a className="downloadText" href="/design/images-textures/sector-rideshare.jpg" download>
                      Download
                      <span className="material-symbols-rounded">download</span>
                    </a>
                  </div>
                  <div
                    className="small-12 medium-4 centered-text full-height small-padding">
                    <img src={'/design/images-textures/sector-streaming.jpg'} className="full-width small-bottom-margin" alt="street pedestrian image" />
                    <a className="downloadText" href="/design/images-textures/sector-streaming.jpg" download>
                      Download
                      <span className="material-symbols-rounded">download</span>
                    </a>
                  </div>
                  <div
                    className="small-12 medium-4 centered-text full-height small-padding">
                    <img src={'/design/images-textures/texture-lines-teal.png'} className="full-width small-bottom-margin" alt="background texture geometric shatter triangles in yipit brand colors" />
                    <a className="downloadText"  href="/design/images-textures/texture-lines-teal.png" download>
                      Download
                      <span className="material-symbols-rounded">download</span>
                    </a>
                  </div>
                  <div
                    className="small-12 medium-4 centered-text full-height small-padding">
                    <img src={'/design/images-textures/texture-lines-light.png'} className="full-width small-bottom-margin" alt="white background texture geometric shatter triangles" />
                    <a className="downloadText" href="/design/images-textures/texture-lines-light.png" download>
                      Download
                      <span className="material-symbols-rounded">download</span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </DesignSection>
        </div>
      </div>
    );
  }
}
